{
  "common": {
    "show": "Exibir",
    "about": "Sobre",
    "newPost": "Nova publicação",
    "active": "Ativo",
    "change": "Alterar",
    "remove": "Remover",
    "cancel": "Cancelar",
    "publish": "Publicar",
    "save": "Salvar",
    "draft": "Rascunho",
    "scheduled": "Programado",
    "published": "Publicado",
    "actions": "Ações",
    "archive": "Arquivar",
    "delete": "Excluir",
    "edit": "Editar",
    "edited": "Editado",
    "settings": "Configurações",
    "signUp": "Cadastrar-se",
    "by": "Via",
    "for": "para",
    "you": "Você",
    "one": "um",
    "option": "Opção ",
    "registered": "Registrado",
    "to": "para",
    "allEvents": "Todos os eventos",
    "placeholder": "placeholder",
    "percentOf": "% de",
    "private": "Privado",
    "updatedOn": "Atualizado(a) em",
    "blogPost": "Publicar no blog",
    "category": "Categoria",
    "author": "Autor",
    "status": "Status",
    "errors": {
      "label": "Erros",
      "SOMETHING_WENT_WRONG": "Algo deu errado. Tente novamente mais tarde."
    },
    "all": "Todos",
    "archived": " Arquivado",
    "back": "Voltar",
    "restore": "Restaurar esta versão",
    "next": "Seguinte",
    "previous": "Anterior",
    "continue": "Continuar",
    "continueButton": "Continuar",
    "paid": "Pago",
    "free": "Gratuito",
    "uploadImagesVideos": "Carregar imagens/vídeos",
    "upload": "Carregar",
    "add": "Adicionar",
    "on": "Ativado",
    "from": "de",
    "members": "membros",
    "visibility": "Visibilidade",
    "public": "Público",
    "description": "Descrição",
    "managedBy": "Gerenciado por",
    "noManagers": "Sem gerentes",
    "noDescription": "Sem descrição",
    "more": "mais",
    "moreCaps": "Mais",
    "less": "menos",
    "and": "e",
    "in": "in",
    "allSet": "Tudo pronto!",
    "createdBy": "Criado por",
    "home": "Página inicial",
    "selected": "Selecionado",
    "groupMembers": "Membros do Grupo",
    "everyone": "Todo mundo",
    "manager": "Gerente",
    "leave": "Sair",
    "membersList": "Lista de Membros",
    "findChannelManagers": "Descobrir gerentes de canal",
    "searchGroupMembers": "Pesquisar Membros do Grupo",
    "searchMembers": "Pesquisar Membros",
    "searchMember": "Pesquisar Membro",
    "enterDescription": "Digite a descrição",
    "apply": "Aplicar",
    "selectRole": "Selecione a função",
    "people": "Pessoas",
    "viewProfile": "Visualizar perfil",
    "leaderboard": "Tabela de classificação",
    "events": "Eventos",
    "logOut": "Sair",
    "topLevelReached": "Nível máximo alcançado",
    "topLevelReachedExclaim": "Nível máximo alcançado!",
    "congratsTopLevel": "Parabéns! Você alcançou o nível máximo!",
    "share": "Compartilhar",
    "copyLink": "Copiar link",
    "reply": "Responder",
    "download": "Baixar",
    "noPreviewAvailable": "Nenhuma pré-visualização disponível",
    "userNotFound": "Usuário não encontrado",
    "userNotFoundMessage": "Usuário não encontrado",
    "thisGroupIsPrivate": "Este grupo é privado",
    "unableToPreviewPdf": "No momento, não é possível pré-visualizar o arquivo PDF. Baixe para visualizar.",
    "failedToDownloadPdf": "Falha ao baixar o arquivo PDF",
    "notifyAll": "Notifique todos no canal",
    "communities": "Comunidades",
    "courses": "Cursos",
    "affiliates": "Afiliados",
    "chats": "Chat",
    "switchToDarkMode": "Mudar para o modo escuro",
    "switchToLightMode": "Mudar para o modo Claro",
    "editProfile": "Editar perfil",
    "account": "Conta",
    "logout": "Logout",
    "noResults": "Nenhum resultado",
    "confirmPayment": "Confirmar pagamento",
    "done": "Concluído",
    "manage": "GERENCIAR",
    "copied": "Copiado",
    "submit": "Enviar",
    "request": "Solicitações",
    "approve": "Aprovar",
    "decline": "Recusar",
    "comingSoon": "Em breve",
    "detailsUpdatedSuccessfully": "Detalhes atualizados com sucesso",
    "oopsUnableToSaveDetails": "Ops! Não foi possível salvar os detalhes.",
    "verificationFailedPleaseTryAgain": "A verificação falhou! Tente novamente",
    "loading": "Carregando",
    "title": "Título",
    "addLink": "Adicionar link",
    "writeHere": "Escreva aqui",
    "copy": "Copiar",
    "reset": "Redefinir",
    "register": "Registrar",
    "search": "Pesquisar",
    "confirm": "Confirmar",
    "success": "Sucesso",
    "toReview": "Para Avaliação",
    "invite": "Convidar",
    "contributions": "Contribuições",
    "communitiesSettings": "Configurações da comunidade",
    "create": "Criar",
    "name": "Nome",
    "linkCopied": "Link Copiado!",
    "move": "Mover",
    "irreversible": "irreversível",
    "close": "Fechar",
    "greeting": "Oi, {name}!",
    "managePayments": "Gerenciar pagamentos",
    "manageYourAccount": "Gerenciar sua Conta",
    "accountSettings": "Configurações da Conta",
    "proceed": "Prosseguir",
    "uploading": "Carregando",
    "retry": "Tentar de novo",
    "login": "Login",
    "follow": "Seguir",
    "following": "Seguindo",
    "followers": "Seguidores",
    "view": "VISUALIZAR",
    "selectAnOption": "Selecione uma opção",
    "channels": "Canais",
    "somethingWentWrong": "Algo deu errado. Tente de novo.",
    "switchToNormalMode": "Mudar para o modo normal",
    "switchToReadingMode": "Alterne para o modo de leitura",
    "goToHomepage": "Ir para a Página Inicial",
    "onlyGroupOwnersCanCreateCourses": "Somente os proprietários do grupo podem criar novos cursos",
    "createGroup": "Criar grupo",
    "discover": "Descobrir",
    "continuePayment": "Continuar pagamento",
    "invalidCredentials": "Você inseriu um e-mail ou senha inválidos. Tente de novo.",
    "comingUpEvents": "Próximos eventos!",
    "integratePaymentGateway": "Integrar gateway de pagamento",
    "connectPaymentGateway": "Conecte um novo gateway de pagamento ou gerencie os atuais.",
    "isLive": "está ao vivo",
    "justNow": "Agora mesmo",
    "likes": "Curtidas",
    "accessRequired": "Acesso*",
    "zeroProgress": "0",
    "noFollowersTitle": "Parece que ninguém segue você.",
    "noFollowersSubtext": "Adicione sua conexão à lista de seguidores",
    "noFollowingTitle": "Você ainda não está seguindo ninguém.",
    "noFollowingSubtext": "Comece a seguir as pessoas para ver suas publicações",
    "followBack": "Seguir de volta",
    "logIn": "LOG IN",
    "video": "Vídeo",
    "audio": "Áudio",
    "newVersionAvailable": "Uma nova versão do app está disponível. Atualize para usar este recurso.",
    "ariaLabels": {
      "backButton": "Botão Voltar",
      "openEventLocation": "Abrir localização do evento",
      "editEvent": "Editar evento",
      "deleteEvent": "Excluir evento",
      "cancelRsvp": "Cancelar RSVP",
      "publicGroupRadio": "Botão de opção de comunidade pública",
      "privateGroupRadio": "Botão de opção de comunidade privada",
      "accessibleFromSwitcherCheckbox": "Caixa de seleção Acessível a partir do comutador",
      "allowMembersToInviteCheckbox": "Caixa de seleção Permitir que os membros convidem",
      "addMembers": "Adicionar membros",
      "settings": "Configurações",
      "leaveChannel": "Sair do canal",
      "channelSettings": "Configurações do Canal",
      "selectRole": "Selecionar função",
      "deleteChannel": "Excluir canal",
      "changeToPrivateChannel": "Alterar para o canal privado",
      "allowMembersToPosts": "Permitir que os membros publiquem",
      "restrictMembersFromPosts": "Impedir que membros enviem publicações",
      "close": "Fechar",
      "open": "Abrir",
      "more": "Mais",
      "upload": "Carregar",
      "play": "Reproduzir",
      "pause": "Pausar",
      "mute": "Mudo",
      "unmute": "Ativar som",
      "fullscreen": "Tela cheia",
      "exitFullscreen": "Sair da tela cheia",
      "download": "Baixar",
      "share": "Compartilhar",
      "like": "Curtir",
      "comment": "Comentário",
      "reply": "Responder",
      "pin": "Fixar",
      "unpin": "Desafixar",
      "report": "Relatório",
      "copyLink": "Copiar link",
      "embedCode": "Código de incorporação",
      "previewImage": "Imagem de pré-visualização",
      "profileImage": "Imagem de perfil",
      "coverImage": "Imagem de capa",
      "thumbnail": "Miniatura",
      "attachment": "Anexo",
      "removeAttachment": "Remover anexo",
      "uploadFile": "Carregar arquivo",
      "selectFile": "Selecionar arquivo",
      "searchIcon": "Ícone de pesquisa",
      "menuIcon": "Ícone de menu",
      "notification": "Notificação",
      "messages": "Mensagens",
      "profile": "Perfil",
      "logout": "Logout",
      "send": "Enviar",
      "cancel": "Cancelar",
      "submit": "Enviar",
      "next": "Seguinte",
      "previous": "Anterior",
      "refresh": "Atualizar",
      "filter": "Filtrar",
      "sort": "Classificar",
      "view": "Visualizar",
      "expand": "Mostrar mais",
      "collapse": "Recolher",
      "downloadFile": "Baixar arquivo",
      "closeModal": "Fechar modal",
      "addMedia": "Adicionar mídia",
      "lightModeRadio": "Botão de opção de modo Claro",
      "darkModeRadio": "Botão de opção do Modo Escuro",
      "communityThemeRadio": "Botão de opção do Tema da comunidade",
      "userProfile": "Perfil do Usuário",
      "postActions": "Ações da publicação",
      "chatWindow": "Janela de Chat",
      "chatActions": "Ações do chat",
      "minimizeChat": "Minimizar chat",
      "closeChat": "Fechar chat",
      "commentActions": "Ações de comentário",
      "replyToComment": "Responder ao comentário",
      "groupLogo": "Logotipo do grupo",
      "pinGroupIcon": "Fixar ícone do grupo",
      "appSwitcher": "Comutador de app",
      "communities": "Comunidades",
      "courses": "Cursos",
      "search": "Pesquisar",
      "giphyLogo": "Logotipo Giphy",
      "backToConversations": "Voltar para conversas",
      "commentAttachments": "Anexos de Comentários",
      "tabSwitcher": "Comutador de Guias",
      "eventCover": "Capa do evento",
      "eventCoverPreview": "Pré-visualização da capa do evento",
      "selectPaidEvent": "Selecione Evento Pago",
      "selectFreeEvent": "Selecionar evento gratuito",
      "selectCurrency": "Selecionar moeda",
      "logo": "Logotipo",
      "closeReviewMembershipAnswersModal": "Fechar modal de revisão de respostas de assinatura",
      "liveStream": "Transmissão ao vivo",
      "openGroupMembers": "Abrir membros da comunidade",
      "communityBanner": "Banner da comunidade",
      "home": "Página inicial",
      "mentionItem": "Mencionar Item",
      "back": "Voltar",
      "viewGroup": "Exibir grupo",
      "invitationIcon": "Ícone de Convite",
      "openUserProfile": "Abrir Perfil do Usuário",
      "closeStream": "Fechar fluxo",
      "groupAvatar": "Avatar do grupo",
      "bannerImage": "Imagem do banner",
      "avatarImage": "Imagem de avatar",
      "userAvatar": "Avatar do usuário",
      "eventImage": "Imagem do evento",
      "postImage": "Imagem da publicação",
      "channelIcon": "Ícone do Canal",
      "groupIcon": "Ícone de grupo",
      "communityIcon": "Ícone da comunidade",
      "memberAvatar": "Avatar do membro",
      "creatorAvatar": "Avatar do construtor",
      "authorAvatar": "Avatar do autor",
      "aboutFeaturedPost": "Sobre a publicação em destaque",
      "accountSettings": "Configurações da conta",
      "addChannel": "Adicionar canal",
      "addCourse": "Adicionar curso",
      "addEmoji": "Adicionar emoji",
      "affiliates": "Afiliados",
      "announceEvents": "Anunciar eventos",
      "avatar": "Avatar",
      "badge": "Emblema",
      "camera": "Câmera",
      "cardImage": "Imagem do Cartão",
      "categoryName": "Nome da categoria",
      "channelList": "Lista de Canais",
      "channelSelect": "Seleção de canal",
      "chatAttachment": "Anexo de Chat",
      "chats": "Chats",
      "closeCourseDetails": "Fechar detalhes do curso",
      "closeLoginModal": "Fechar Modal de Login",
      "closeMembershipQuestionsModal": "Fechar modal de perguntas sobre assinatura",
      "closePaymentModal": "Fechar modal de Pagamento",
      "commentCard": "Cartão de comentários",
      "communityTheme": "Tema da comunidade",
      "conversationItem": "Item de chat",
      "conversationSuggestion": "Sugestão de chat",
      "createChannel": "Criar canal",
      "customThemeRadio": "Botão de opção de tema personalizado",
      "deleteAnswerButton": "Botão Excluir resposta",
      "deleteFile": "Excluir arquivo",
      "editLevelName": "Editar nome do nível",
      "editProfile": "Editar perfil",
      "enterEmailAddress": "Insira o endereço de e-mail",
      "featuredIcon": "Ícone Destacado",
      "giveAdministrativePrivileges": "Conceder privilégios administrativos",
      "gokollabLogo": "Logotipo da Gokollab",
      "icon": "Ícone",
      "image": "Imagem",
      "likeContent": "Curtir conteúdo",
      "link": "Link",
      "marketplaceGroupSlug": "Slug do grupo do Marketplace",
      "microphone": "Microfone",
      "nextAttachment": "Próximo Anexo",
      "noEvents": "Nenhum evento",
      "noCommunitiesIllustration": "Nenhuma ilustração de comunidades",
      "noCoursesFound": "Nenhum curso encontrado",
      "noFollowers": "Sem seguidores",
      "noFollowing": "Sem seguidores",
      "noPostsFound": "Nenhuma publicação encontrada",
      "notificationItem": "Item de notificação",
      "notificationsList": "Lista de notificações",
      "openEmbeds": "Abrir incorporações",
      "openEmbedsDrawer": "Abrir gaveta de incorporações",
      "openEventColor": "Cor de Abrir evento",
      "openEventDetails": "Abrir detalhes do evento",
      "permissionNeeded": "Permissão necessária",
      "pointsAndLevels": "Pontos e níveis",
      "previousAttachment": "Anexo anterior",
      "reactedUser": "Usuário que reagiu",
      "reward": "Recompensa",
      "rewards": "Recompensas",
      "selectChannel": "Selecione o canal",
      "selectEventOption": "Selecione a opção de evento",
      "selectIcon": "Selecione o ícone",
      "selectTimezone": "Selecione o fuso horário",
      "showChannelIcons": "Exibir ícones do Canal",
      "sidebarActionButton": "Botão de Ação da Barra Lateral",
      "speaker": "Alto-falante",
      "text": "Texto",
      "thisGroupIsPrivate": "Este grupo é privado",
      "toReview": "Para avaliação",
      "toggleFeaturedPost": "Alternar publicação em destaque",
      "toggleRewardsOptions": "Alternar Opções de Recompensas",
      "viewReplies": "Visualizar respostas",
      "courseThumbnail": "miniatura-do-curso",
      "moreManagers": "mais gerentes",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Alterar para o canal público",
      "showMandatoryInfoModal": "Exibir caixa de seleção obrigatória do modal de perfil"
    },
    "placeholders": {
      "groupName": "Nome do grupo",
      "groupSlug": "Slug do grupo",
      "url": "URL",
      "enterPrice": "Insira o preço",
      "enterName": "Insira o nome",
      "enterEmail": "Insira o e-mail",
      "selectTimezone": "Selecione o fuso horário",
      "selectChannel": "Selecione Canal",
      "enterSkoolGroupUrl": "Insira o URL do seu grupo Skool"
    },
    "email": "E-mail",
    "errorLoadingConversations": "Falha ao carregar chats",
    "noConversations": "Nenhum chat"
  },
  "imageUpload": {
    "cropYourAvatar": "Corte seu avatar",
    "dragToReposition": "Arraste para reposicionar",
    "ariaLabels": {
      "imageUploader": "Carregador de imagens",
      "avatar": "Avatar",
      "clearFile": "Limpar arquivo",
      "removeAvatar": "Remover avatar de perfil",
      "zoomButton": "Botão Zoom"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Carregar vídeo",
    "addVideoUsingLink": "Adicionar vídeo usando link",
    "uploadImage": "Carregar imagem",
    "addVideo": "Adicionar vídeo"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Conclua seu perfil",
    "profileIntentMessage1": "As comunidades parecem estranhas sem rostos e nomes.",
    "profileIntentMessage2": "Perfis geram confiança e estimulam a conexão com outras pessoas",
    "complete": "CONCLUIR",
    "recommendedAspectRatio": "Carregar um {types}. Porcentagem de Aparência Recomendado 1:1",
    "addBio": "Adicione uma biografia... (Opcional)"
  },
  "validations": {
    "nameRequired": "O nome é obrigatório!",
    "invalidDescription": "Descrição inválida!"
  },
  "payment": {
    "recurringWithTrial": "Você será cobrado {currencySymbol}{price} por {interval} após o término do período de teste, com a opção de cancelar a qualquer momento.",
    "recurring": "{currencySymbol}{price} por {interval} com a opção de cancelar a qualquer momento.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "Preço único por assinatura.",
    "totalAmount": "Valor total",
    "viewBreakdown": "Visualizar detalhamento",
    "hideBreakdown": "Ocultar detalhamento",
    "subtotal": "Subtotal",
    "salesTax": "Imposto sobre vendas",
    "taxesMayApply": "Os impostos podem ser aplicados na finalização da compra.",
    "inclTax": "Incl. impostos",
    "totalDueToday": "Total devido hoje",
    "trialDays": "Teste de {days} dias",
    "securePayments": "Pagamentos totalmente seguros e protegidos",
    "allowToChargeCard": "Ao fornecer as informações do seu cartão, você permite que {locationName} cobre o cartão para pagamentos futuros de acordo com os termos.",
    "address": {
      "country": "País",
      "state": "Estado",
      "zipCode": "Código postal",
      "city": "Cidade",
      "addressLine1": "Linha de endereço 1",
      "addressLine2": "Linha de Endereço 2 (opcional)",
      "streetAndNumber": "Rua e número",
      "apartmentAndUnit": "Apartamento, suíte, unidade, edifício, andar, etc.",
      "selectCountry": "Selecione o país",
      "selectState": "Selecione o estado",
      "calculatingTaxes": "Cálculo de impostos",
      "continueToPayment": "Continuar para pagamento",
      "validationError": "Por gentileza, preencha todos os campos obrigatórios de endereço.",
      "taxInfo": "Utilizamos o seu endereço apenas para calcular os impostos aplicáveis."
    },
    "paymentSuccessful": "Pagamento efetuado!",
    "errors": {
      "FDS_DECLINED": "Sua transação foi recusada. Entre em contato com o proprietário da empresa."
    }
  },
  "channel": {
    "notifications": {
      "managersEdited": "Gerentes editados com sucesso!",
      "managersAdded": "Gerentes adicionados com sucesso!",
      "managersAddedToChannel": "gerentes adicionados a",
      "membersAdded": "Membros adicionados com sucesso!",
      "memberPostingEnabled": {
        "title": "Atualizado Membros com sucesso",
        "content": "A publicação de Membros foi habilitada"
      },
      "roleUpdated": "Função atualizada com sucesso!",
      "updatedRoleOf": "Função de {name} atualizada",
      "userRemoved": "Usuário apagado com sucesso!",
      "removedUserFrom": "{name} apagado de {channelName}",
      "errorOccurred": "Ocorreu um erro",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND": "Não foi possível atualizar a função porque o membro não pôde ser encontrado.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN": "Esta ação não é permitida para o proprietário do grupo.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND": "Não foi possível remover o usuário porque o membro não pôde ser encontrado.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND": "Não foi possível remover o usuário porque este canal não foi encontrado.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN": "O proprietário do grupo não pode ser removido do canal.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL": "Este usuário não faz parte do canal selecionado.",
      "updated": {
        "title": "Configurações de canal atualizadas",
        "contentPrivate": "O canal {channelName} é agora privado",
        "contentPublic": "O canal {channelName} é agora público",
        "content": ""
      },
      "deleted": {
        "title": "Canal excluído com sucesso",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Membros adicionados com sucesso!",
        "content": "{count} membros adicionados a {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Gerentes adicionados com sucesso!",
        "content": "{count} gerentes adicionados a {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Atualizado Membros com sucesso",
        "content": "A publicação de Membros foi desabilitada"
      },
      "visibilityChangedToPublic": "O canal {channelName} agora é público",
      "visibilityChangedToPrivate": "O canal {channelName} agora é privado",
      "created": {
        "title": "Novo canal criado",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Falha ao criar canal",
          "content": "Tente novamente mais tarde"
        },
        "updateFailed": {
          "title": "Falha ao atualizar canal",
          "content": "Tente novamente mais tarde"
        },
        "managersEditedFailed": {
          "title": "Atualização de gerentes sem sucesso!",
          "content": ""
        },
        "addFailed": {
          "title": "Adição de gerentes sem sucesso!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Adição de membros sem sucesso!",
          "content": ""
        }
      }
    },
    "createChannel": "Criar canal",
    "updateChannel": "Atualizar canal",
    "addMembers": "Adicionar Membros",
    "addManagers": "Adicionar Gerentes",
    "typeToAddMoreMembers": "Digite para adicionar mais membros",
    "examplePlaceholder": "por ex., João ou Jane",
    "makeChannelManager": "Criar Gerenciador de Canais",
    "removeFromChannelManager": "Remover do gerenciador de canais",
    "manager": "Gerente",
    "channelManager": "Gerente do canal",
    "noMembersFound": "Nenhum membro encontrado.",
    "noManagersFound": "Nenhum gerente encontrado.",
    "removeChannelMember": "Remover membro do canal",
    "removeConfirmationMessage": "Tem certeza de que deseja remover",
    "makeManagerConfirmationMessage": "Tem certeza de que deseja criar",
    "makeManagerConfirmationMessage2": "um gerente de canal em",
    "channelName": "Nome do Canal",
    "channelIcon": "Ícone do Canal",
    "addChannel": "Adicionar canal",
    "editChannel": "Editar canal",
    "announcementChannel": "Canal AVSO",
    "noChannelsAvailable": "Nenhum canal disponível",
    "makeChannelPrivate": "Tornar o canal privado",
    "makeChannelPrivateMessage": "Restringir o acesso dos membros a todas as discussões do canal e interações.",
    "readOnlyChannel": "Canal somente Ler",
    "readOnlyChannelMessage": "Os Membros podem Visualizar informações e atualizações IMPORTANTEs, mas somente administradores/ proprietários do canal podem Compartilhar aqui.",
    "createPrivateChannel": "Tornar este canal privado",
    "createPrivateChannelMessage": "Somente Membros convidados. Não Membros não verá este Espaço",
    "allowMembersToPost": "Habilitar Membros para Compartilhar",
    "allowMembersToPostMessage": "Ativando esta opção Habilitar Membros para Criar publicações e feedback",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Ativar a publicação de Membros habilitará todos os Membros para Criar e Compartilhar publicações no canal.",
      "mainMessage2": "Certifique-se de que todos os membros estejam atualizados das novas permissões de publicação.",
      "pointer1": "Esta ação pode ser revertida em qualquer Data.",
      "pointer2": "todas as publicações criadas por Membros ficarão visíveis para Todo o mundo in canal."
    },
    "privateChannelTooltip": "Você não tem acesso a este canal",
    "restrictMembersFromPosting": "Redirecionar Membros De publicação",
    "restrictMembersFromPostingMessage": "Desabilitar esta opção evitará que os Membros De Criados Ou edite publicações e feedback dentro do canal.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Desabilitar a publicação de Membros impedirá todos os Membros De Criado e o compartilhamento de publicações no canal.",
      "mainMessage2": "Certifique-se de que todos os membros estejam alertas das novas restrições de publicação.",
      "pointer1": "Esta ação pode ser revertida em qualquer Data.",
      "pointer2": "todas as publicações criadas por Membros Antes desta Alterar permanecerão visíveis para Todo o mundo in canal."
    },
    "deleteChannel": "Excluir canal",
    "deleteChannelMessage": "A exclusão do canal resultará na perda permanentemente de todos os dados associados.",
    "deleteChannelMessageWithCourse": "A exclusão do canal resultará na perda permanentemente de todos os dados de Membros e quaisquer Cursos vinculados a este canal se Tornarão Público, a menos que Você os exclua primeiro.",
    "editChannelName": "Editar Nome do Canal",
    "editChannelDescription": "Editar descrição do canal",
    "channelNamePlaceholder": "por exemplo, relatórios de marketing",
    "editManagers": "Editar gerenciadores",
    "channelManagers": "Gerentes de Canal",
    "leaveChannel": "Sair do canal",
    "leaveChannelConfirmation": "Tem certeza de que deseja sair este canal?",
    "changeToPrivateChannel": "Tornar o canal privado",
    "changeToPrivateChannelMessage": "Ao tornar o canal privado o uso do canal será restringido para interações e discussões apenas aos seus membros.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Mudar este canal para Privado resultará no Limite de intervalos de acesso a selecionados Membros e gerentes apenas.",
      "mainMessage2": "Lembre-se de incluir todos os membros desejados ao seu canal Privado.",
      "pointer1": "Esta ação é",
      "pointer2": "novos Membros adicionados ao canal terão Acesso a todos PASSADO debates e interações dentro do canal."
    },
    "changeToPublicChannel": "Tornar o canal público",
    "changeToPublicChannelMessage": "Tornar o Canal público permitirá que todos os Membros do grupo visualizem e participem neste Canal.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Tornar este canal público tornará acessível a todos os membros da comunidade.",
      "mainMessage2": "Todo mundo do Grupo poderá Visualizar e participar neste Canal.",
      "pointer1": "Todo mundo Membros terão Login a este Canal automaticamente.",
      "pointer2": "O Mídia PASSADO de um Canal Privado ficará visível para Todo mundo os Membros do Grupo."
    },
    "publicChannel": "Canal público",
    "peopleWhoCanManage": "Pessoas que podem gerenciar",
    "addChannelHelperText": "Mostrar mais comunidade: Adicionar canais para diferentes debates, Duet e conexão.",
    "privateChannel": "Canal Privado",
    "removeFromChannel": "Remover do canal",
    "removeConfirmationMessage2": "deste canal",
    "findChannelManagers": "Descobrir gerentes de canal",
    "removeChannelManager": "Remover gerente de canal",
    "irreversible": "Essa ação é irreversível"
  },
  "chat": {
    "unblockUser": "Desbloquear usuário",
    "blockUser": "Bloquear usuário",
    "blockMessage1": "Você não poderá mais enviar mensagens para este usuário.",
    "blockMessage2": "Essa conta não será bloqueada no grupo. You ainda poderá ver suas publicações, feedbacks e reações.",
    "deleteChat": "Excluir chat",
    "deleteChatMessage": "Tem certeza de que deseja excluir este chat?",
    "block": "Bloquear",
    "conversation": "chat",
    "youPrefix": "Você: ",
    "messageNotSent": "Esta mensagem não foi enviada",
    "sending": "Enviando",
    "youAndUserKnowEachOther": "Você e {name} se conhecem",
    "startConversationWithHi": "Inicie uma conversa enviando \"Oi\"",
    "accountSettings": "Configurações da conta",
    "blockedUserMessage": "Você bloqueou { name }. Você não pode enviar ou receber mensagens. Desbloqueie-os para iniciar um chat. Para revisar sua lista de usuários bloqueados, visite seu",
    "blockRecipientMessage": "{ name } bloqueou você. Você não pode enviar ou receber mensagens.",
    "nothingFound": "Nada foi encontrado!",
    "pleaseCheckUsername": "Por favor, verifique o nome de usuário e tente novamente",
    "startChatting": "Comece a conversar por chat",
    "noChatYet": "Parece que você ainda não conversou com ninguém.",
    "noChatYetMessage": "Pesquise um contato e dê o primeiro passo!",
    "noConversationsFound": "Nenhuma conversa encontrada",
    "searchMembersAndStartChatting": "Pesquise membros e comece a conversar",
    "cannotMessageDeletedUser": "Você não pode carregar mensagens para um usuário Apagado",
    "message": "Mensagem",
    "media": "Mídia",
    "files": "Arquivos"
  },
  "comments": {
    "reportComment": "Denunciar comentário",
    "reportCommentMessage": "Tem certeza de que deseja denunciar este comentário?",
    "deleteComment": "Excluir comentário",
    "editComment": "Editar comentário",
    "loadMoreReplies": "Carregar mais respostas",
    "deleteCommentMessage": "Tem certeza de que deseja excluir este comentário?",
    "writeComment": "Escreva um comentário",
    "comment": "COMENTÁRIO",
    "cancel": "CANCELAR",
    "save": "SALVAR",
    "replyingTo": "Respondendo a",
    "newComment": "novo comentário",
    "latest": "Mais recente",
    "onlyAdminsCanComment": "Somente administradores da comunidade podem comentar in canal.",
    "isCommentDisabledForPost": "O feedback está Desabilitado para este Compartilhar.",
    "isCommentDisabledErrorContent": "Feedback foram desabilitado nesta compartilhamento pelo editor ou pelo administrador do Grupo.",
    "isCommentDisabledErrorTitle": "Feedback Desabilitados",
    "notifications": {
      "saveComment": "Erro ao salvar o comentário",
      "error": "Ocorreu um erro. Tente novamente mais tarde.",
      "COMMENT_CONTENT_SIZE_EXCEEDED": "O conteúdo do comentário é grande demais. Reduza o tamanho e tente novamente.",
      "COMMENTS_DISABLED": "Os comentários foram desabilitados nesta publicação pelo autor ou pelo administrador do grupo."
    }
  },
  "embeds": {
    "uploadImage": "Carregar imagem",
    "addYoutubeVimeoLoomLink": "Adicione um link do Youtube, Vimeo ou Loom",
    "uploadAttachment": "Carregar arquivos PDF, CSV ou XLSX",
    "addAttachment": "Adicionar anexo",
    "allowedTypes": "SVG, PNG, JPG ou GIF (máx. 800 x 400 px)",
    "placeholder": "Adicione um link do Youtube, Vimeo ou Loom",
    "uploadVideo": "Carregar/vincular vídeo",
    "uploadVideoPlaceholder": "Adicione um link do Youtube, Vimeo ou Loom",
    "uploadVideoAllowedTypes": "Carregar um arquivo de vídeo MP4",
    "addEmoji": "Adicionar emoji",
    "emojiSuggestion": "Abre o seletor de emojis",
    "addGif": "Adicionar GIF",
    "gifSuggestion": "Abre o seletor de GIFs",
    "addImage": "Adicionar imagem",
    "imageSuggestion": "Abre sua galeria",
    "addVideo": "Adicionar vídeo",
    "videoSuggestion": "Abre sua galeria",
    "selectFile": "Selecionar arquivo",
    "attachmentSuggestion": "Abre o gerenciador de arquivos",
    "takePhoto": "Tirar foto",
    "uploadPhotoVideo": "Carregar foto/vídeo",
    "limitExceeded": "Limite excedido",
    "limitExceededMessage": "Você não pode anexar mais de quatro arquivos",
    "errorWhileUploadingFile": "Erro ao enviar arquivo! Tente novamente",
    "notifications": {
      "uploadError": "Erro ao carregar o arquivo",
      "FILE_SIZE_EXCEEDED": "O tamanho do arquivo excede o limite máximo de upload de 50 MB.",
      "VIDEO_SIZE_EXCEEDED": "O tamanho do vídeo excede o limite máximo de upload de 1 GB."
    },
    "clickToUpload": "Clique para carregar",
    "orDragAndDrop": "ou arraste e solte",
    "validUrl": "É necessário um URL válido",
    "enterSomeText": "Insira algum texto",
    "addLink": "Adicionar link",
    "text": "Texto",
    "addVideoLink": "Ou, Incluir um YouTube, Vimeo, Loom, Ou Wistia Vídeo Link.",
    "uploadVideoAndImages": "Carregar vídeos e imagens",
    "recommendedAspectRatio": "Porcentagem de Aparência Recomendado {ratio}",
    "addHashtag": "Rótulo canais, ocorrências e Cursos",
    "hashtagSuggestion": "Sugestão de hashtag"
  },
  "tabSwitcher": {
    "discussion": "Discussão",
    "learning": "Aprendizado",
    "members": "Membros",
    "people": "Pessoas",
    "leaderboard": "Tabela de classificação",
    "channels": "Canais",
    "groups": "Grupos",
    "more": "Mais",
    "home": "Página inicial",
    "discover": "Descobrir",
    "courses": "Cursos",
    "communities": "Comunidades"
  },
  "groupInfo": {
    "pinGroup": "Fixar Grupo",
    "unpinGroup": "Desafixar Grupo",
    "maxPinnedGroupsLimit": "Somente até 4 Grupos podem ser fixados",
    "publicGroup": "Grupo público",
    "privateGroup": "Grupo privado",
    "coverImage": "Capa do grupo",
    "members": "Membros",
    "posts": "Publicações",
    "admin": "Administrador",
    "settings": "CONFIGURAÇÕES",
    "inviteMembers": "CONVIDAR MEMBROS",
    "answerQuestions": "Responder perguntas",
    "toJoin": "para participar de {name}",
    "leaveGroup": "Sair do Grupo",
    "leaveGroupConfirmMessage": "Tem certeza de que deseja sair deste grupo? Você perderá o acesso a todos os cursos pagos, eventos pagos e à sua participação no grupo.",
    "leaveGroupSuccessTitle": "Você saiu do grupo",
    "leaveGroupSuccessMessage": "Você saiu do grupo com sucesso.",
    "leaveGroupErrorTitle": "Não foi possível sair do grupo.",
    "leaveGroupErrorMessage": "Algo deu errado ao sair do grupo. Tente de novo.",
    "groupActions": "Ações de grupo",
    "changeRole": "Alterar função",
    "removeFromGroup": "Remover do grupo",
    "contributor": "Colaborador",
    "membershipAnswers": "Respostas sobre a assinatura",
    "unbanMember": "Cancelar banimento do membro",
    "banFromGroup": "Banir do grupo",
    "requestedOn": "Solicitado em",
    "invitedOn": "Convidado em",
    "joinedOn": "Entrou",
    "noMembersFound": "Nenhum membro encontrado.",
    "youAreAllCaughtUp": "Você está todos atualizados — não Membros aqui Direita agora!",
    "banUserConfirmation": "Tem certeza de que deseja banir este usuário do grupo?",
    "deleteContentCheckbox": "Excluir todos os conteúdo criado por este usuário",
    "active": "Ativo",
    "admins": "Administradores",
    "contributors": "Colaboradores",
    "requested": "Solicitado",
    "banned": "Banido",
    "invited": "Convidado",
    "paymentReceived": "Pagamento recebido",
    "paymentInitiated": "Pagamento Iniciado",
    "answeredQuestions": "Perguntas respondidas",
    "answeredQuestionsMessage": "respondeu à seguinte pergunta para participar",
    "darkMode": "Modo escuro",
    "darkModeMessage": "Ajuste a aparência da comunidade para reduzir o brilho e dar um descanso aos olhos.",
    "accessGranted": "Login concedido: comece sua aventura de aprendizado.",
    "stepIntoAction": "Entre em ação! Vamos colaborar e nos divertir um pouco.",
    "viewMembersAndMemberDetails": "Visualizar membros e detalhes dos membros",
    "reviewContentReportsAndMore": "Avaliação de relatórios de conteúdo e muito mais",
    "toReview": "Para avaliação",
    "switchToOtherGroups": "Mudar para Outro Grupo",
    "placeholders": {
      "yourAnswer": "Sua resposta"
    },
    "notifications": {
      "userBanned": "Usuário banido do grupo com sucesso",
      "somethingWentWrong": "Algo deu errado. Tente novamente mais tarde."
    },
    "membershipSettings": "Configurações de assinatura",
    "paymentFailed": "O pagamento falhou!",
    "paymentFailedMessage": "O pagamento falhou, sua solicitação para participar do grupo foi recusada.",
    "gamification": {
      "addRewards": "Adicionar Recompensas",
      "title": "Título",
      "description": "Adicionar descrição",
      "textbox": "Caixa de texto",
      "singleSelect": "Seleção única",
      "multipleSelect": "Seleção múltipla",
      "question": "Pergunta",
      "validations": {
        "titleRequired": "Forneça o título",
        "descriptionRequired": "Forneça a descrição",
        "somethingWentWrong": "Algo deu errado. Tente novamente mais tarde.",
        "updatedRewards": "Recompensas Atualizadas"
      },
      "settings": {
        "updatedRewards": "Recompensas atualizadas"
      }
    },
    "customCode": {
      "advanced": "Avançado",
      "testPreview": "Pré-visualização do teste",
      "enableConfirmationMessage": "Habilite-o somente depois de verificar a pré-visualização do teste",
      "testPreviewMessage": "Isso abrirá uma nova aba com a pré-visualização do teste da sua comunidade. Você pode usar isso para verificar se seu código personalizado está funcionando conforme o esperado.",
      "liveMode": "Modo Ao vivo",
      "customJS": "JS Personalizado",
      "customCSS": "CSS Personalizado",
      "trackingCode": "Código de rastreamento",
      "headerCode": "Código do cabeçalho",
      "footerCode": "Código de Rodapé"
    },
    "branding": {
      "brandYourGroup": "Você pode atribuir uma marca preferencial ao seu grupo aqui",
      "updateBranding": "Atualizar a identidade visual",
      "clickToUploadFavicon": "Click para carregar o Favicon",
      "dragAndDropFavicon": "Arrastar e soltar um {types} (proporção de tela 1:1)",
      "clickToUploadCover": "Clique para carregar a capa",
      "dragAndDropCover": "Arrastar e soltar um {types} (proporção de tela 16:9)",
      "clickToUploadLogo": "Clique para carregar o logotipo do grupo",
      "dragAndDropLogo": "Arrastar e soltar um {types} (proporção de tela 1:1)",
      "aspectRatioMustBe1To1": "A proporção de aspecto da imagem deve ser 1:1",
      "aspectRatioMustBe16To9": "A proporção de aspecto da imagem deve ser 16:9",
      "favicon": "Favicon",
      "coverImage": "Imagem de capa",
      "logo": "Logotipo",
      "invalidFileFormat": "Ops! Formato/tipo de arquivo inválido.",
      "pleaseUploadImageType": "Tipos de arquivo compatíveis: {types}"
    },
    "groupAppearance": {
      "description": "Você pode configurar seu grupo Aparência conforme sua escolha aqui",
      "slug": "Atualize seu Grupo Aparência aqui",
      "colorMode": "Modo de Cor",
      "previewTheLook": "Pré-visualizar como seu grupo será Aparência in modo Claro e Escuro",
      "light": "Claro",
      "dark": "Escuro",
      "communityTheme": "Tema da comunidade",
      "customTheme": "Tema Personalizado",
      "windowGradient": "Gradiente da Janela",
      "applyGradientColorsToYourSidebarAndTopbar": "Aplicar cores de Gradiente à barra lateral e barra superior",
      "labels": {
        "sidebarBackground": "Plano de fundo da barra lateral",
        "primary": "PRINCIPAL",
        "secondary": "Secundário",
        "tertiary": "Terciário",
        "surface": "Proporção",
        "fontPrimary": "Fonte PRINCIPAL",
        "fontSecondary": "Fonte recorrente",
        "fill": "Cor de Preencher",
        "border": "Borda",
        "error": "Erro",
        "background": "Plano de fundo",
        "option": "Opção"
      },
      "customThemes": {
        "default": "Padrão",
        "zestyCitrus": "Clássico",
        "royalVelvet": "veludo real",
        "sunnyDelight": "Muito sol",
        "lushMeadow": "Exibindo o campo",
        "azureDreams": "Sonhos do Azul",
        "bubblegumBliss": "Bem-vindo",
        "ivoryWhisper": "Sussurro de Iza",
        "midnightDeep": "Propagação da Meia-feira"
      },
      "unsavedChanges": "Dinâmico não salvo",
      "unsavedChangesMessage": "Você tem o tema Dinâmico não salvo, Tem certeza de que deseja Desfazer o Dinâmico?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Links promocionais",
      "createPromotionalLinkDescription": "Crie links promocionais para seu grupo",
      "addPromotionalLink": "Adicionar link",
      "deleteLink": "Excluir link",
      "deleteLinkConfirmation": "Tem certeza de que deseja excluir este link?",
      "labels": {
        "description": "Descrição",
        "url": "URL",
        "private": "Privado",
        "privateLinksDescription": "Links privados são visíveis apenas para membros do grupo"
      },
      "placeholders": {
        "enterLinkDescription": "Insira a descrição do link",
        "enterLinkURL": "Insira o URL do link"
      },
      "addPromotionalLinkDescription": "Criar Links promocionais para seu grupo",
      "ariaLabels": {
        "editLink": "Editar link",
        "deleteLink": "Excluir link"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Adicionar pergunta",
      "editQuestion": "Editar pergunta",
      "editLevelName": "Editar nome do nível",
      "addOption": "Adicionar opção",
      "level": "Nível",
      "name": "Nome",
      "addMembersQuestionsDescription": "Adicione perguntas para que os membros façam quando solicitarem acesso ao seu grupo",
      "enableMembershipQuestions": "Habilitar perguntas sobre assinatura",
      "membershipQuestions": "Perguntas sobre assinatura",
      "deleteQuestion": "Excluir pergunta",
      "deleteQuestionConfirmation": "Tem certeza de que deseja excluir esta pergunta?",
      "labels": {
        "textBox": "Caixa de texto",
        "singleSelect": "Seleção única",
        "multipleSelect": "Seleção múltipla",
        "enableMembershipQuestions": "Adicionar pelo menos uma Pergunta para Habilitar Filiação"
      },
      "validations": {
        "questionRequired": "Insira a pergunta",
        "answerOptionsRequired": "É necessário um mínimo de duas opções, e elas devem ser únicas",
        "somethingWentWrong": "Algo deu errado. Tente novamente mais tarde.",
        "updatedQuestions": "Perguntas atualizadas sobre assinatura do grupo",
        "levelNameRequired": "Digite o nome do nível",
        "updatedLevelName": "Nome do nível atualizado"
      },
      "placeholders": {
        "enterLevelName": "Nome do nível",
        "selectOne": "Selecione um",
        "keepItShort": "mantenha-o curto.",
        "exampleOffer": "por exemplo 10% Desabilitado Ativado na primeira compra"
      },
      "privacyNotice": "Entendo que minha respostas serão o Arquivar e visíveis para os administradores do Grupo.",
      "ariaLabels": {
        "editQuestion": "Editar pergunta",
        "deleteQuestion": "Excluir pergunta"
      }
    },
    "gamificationAndRewards": {
      "title": "Personalizar Níveis e Recompensas",
      "description": "Personalize os nomes dos níveis e adicione recompensas para um melhor engajamento dos membros",
      "gamification": "Gamificação",
      "rewards": "Recompensas",
      "addRewards": "Adicionar recompensa",
      "ariaLabels": {
        "toggleGamification": "Alternar Opções de Gamificação"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Convite enviado com sucesso",
      "invitationSentSuccessfullyDescription": "Convite enviado para {email}",
      "shareGroupLink": "Compartilhe o link do seu grupo",
      "inviteMember": "Convidar membro",
      "inviteMemberDescription": "Construa sua comunidade convidando um novo membro",
      "inviteViaEmail": "Convidar por email",
      "invitedMembersWillBeAutoApproved": "Os membros convidados serão aprovados automaticamente para ingressar no grupo",
      "sendInvite": "ENVIAR CONVITE",
      "permissionDenied": "Você não tem autorização para solicitar Membros. Entre em contato com seu administrador.",
      "notifications": {
        "INVITATION_CREATE_UNAUTHORIZED": "Você não tem permissão para enviar convites.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE": "Este grupo não permite que os membros convidem outras pessoas.",
        "INVITATION_CREATE_ALREADY_INVITED": "Este usuário já foi convidado.",
        "INVITATION_CREATE_ALREADY_MEMBER": "Este usuário já é membro do grupo."
      },
      "labels": {
        "giveAdministrativePrivileges": "Conceder privilégios administrativos",
        "giveAdministrativePrivilegesDescription": "Habilitar este membro para executar todas as ações administrativas",
        "name": "Nome",
        "email": "E-mail",
        "nameLabel": "Nome",
        "emailLabel": "E-mail"
      },
      "placeholders": {
        "enterName": "Inserir nome",
        "enterEmail": "Inserir e-mail"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Atualizar detalhes do grupo",
      "updateGroupDetailsDescription": "Atualize os detalhes do seu grupo aqui",
      "slugNotAvailable": "Slug do grupo não disponível",
      "description": "Elaborar a natureza dos debates que ocorrerão no grupo",
      "publicDescription": "Qualquer pessoa pode ver as publicações e outros membros do grupo",
      "privateDescription": "Somente membros podem ver as publicações e outros membros do grupo",
      "accessibleFromSwitcher": "Abrir a partir do comutador",
      "accessibleFromSwitcherDescription": "Seu grupo ficará visível para não membros do grupo no Comutador",
      "allowMembersToInvite": "Habilitar Membros para convites novos Membros",
      "allowMembersToInviteDescription": "Ocultar o botão de convite para os Membros Quando ficou Desabilitado. Os membros só podem convidados a Outro Se este é Habilitado.",
      "showMandatoryInfoModal": "Exibir modal de perfil obrigatório",
      "showMandatoryInfoModalDescription": "Quando habilitada, essa opção solicitará que os membros preencham suas informações do perfil ao ingressarem no grupo.",
      "slug": "Slug do grupo",
      "discovery": {
        "title": "Descoberta",
        "description": "Seja encontrado por milhões de usuários ativos. O grupo ficará visível na página Descobrir quando você tiver mais de 10 Membros.",
        "discoverChannels": "Descobrir canais",
        "joinGroupToExploreAllChannels": "participar do grupo para explore todos os canais",
        "categoryIsUsedOnlyOnGokollab": "A categoria é usada apenas no Gokollab",
        "categoryAutomaticallySuggested": "A categoria é sugerida automaticamente usando AI com base no título e na descrição do seu grupo. Para obter sugestões mais precisas, certifique-se de que os detalhes do seu grupo reflitam claramente seu propósito e temas.",
        "categoryRefreshLimited": "A atualização da categoria é limitada a uma vez a cada 24 horas"
      },
      "placeholders": {
        "description": "Insira uma breve descrição"
      },
      "validations": {
        "nameRequired": "Insira um nome de grupo válido!",
        "slugRequired": "Insira um slug de grupo válido!",
        "specialCharacterNotSupported": "Caractere especial não compatível",
        "descriptionRequired": "A descrição do grupo é obrigatória!",
        "emailRequired": "Insira um e-mail válido!",
        "fullNameRequired": "Insira um nome válido!"
      },
      "labels": {
        "groupName": "Nome do Grupo"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Gerenciar sua Assinatura",
      "viewAndManageGroupSubscriptions": "Visualizar e gerenciar o Grupo Assinatura",
      "paymentIntegrationMissingMessage": "Por favor, integre os pagamentos in localização ao Habilitar Pago Grupo",
      "price": "Preço",
      "currency": "Moeda",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Um dado",
      "priceDeletedAlert": "O produto de pagamento é de sincronização, clique aqui para sincronizar novamente",
      "intervals": {
        "month": "Mês",
        "year": "Ano",
        "week": "Semana",
        "day": "Dia"
      },
      "addNewPrice": "Adicionar novo Preço",
      "editPrice": "Editar Preço",
      "addPrice": "Adicionar Preço",
      "subscriptionType": {
        "recurring": "Recorrente",
        "oneTime": "Um dado"
      },
      "billingPeriod": {
        "monthly": "Mensalmente",
        "annually": "Anual",
        "weekly": "Semanalmente",
        "daily": "Diário"
      },
      "ariaLabels": {
        "freeMembership": "Botão de opção para a assinatura gratuita",
        "paidMembership": "Botão de opção para a assinatura paga"
      }
    },
    "menuOptions": {
      "details": "Detalhes",
      "subscriptions": "Assinatura",
      "branding": "Identidade visual",
      "themes": "Tema",
      "tabsConfiguration": "Mostrar/Ocultar Abas",
      "membershipQuestions": "Perguntas sobre Filiação",
      "gamificationAndRewards": "Gamificação e Recompensas",
      "links": "Links",
      "newsletter": "Newsletter",
      "reportedContent": "Conteúdo denunciado",
      "discovery": "Descobrimento",
      "import": "Importar"
    },
    "newsletter": {
      "title": "Newsletter",
      "subheading": "Resumo da Comunidade",
      "frequency": "Frequência da Newsletter",
      "description": "Um Resumo das postagens populares, Atividade dos Membros e ocorrências deste Grupo",
      "time": "Hora",
      "weekday": "Dia útil",
      "monthDay": "Dia do mês",
      "lastDay": "Último dia",
      "selectFrequency": "Selecionar frequência",
      "frequencies": {
        "off": "Desativado",
        "daily": "Diariamente",
        "weekly": "Semanalmente",
        "biweekly": "Quinzenalmente",
        "monthly": "Mensalmente"
      }
    },
    "tabConfiguration": {
      "title": "Mostrar/Ocultar Abas",
      "description": "Controle quais guias aparecem na sua comunidade. Ative ou desative cada aba para criar uma experiência focada e simplificada para os seus membros.",
      "discussionDescription": "Inicie ou participe de conversas para compartilhar atualizações, ideias e insights com a sua comunidade.",
      "learningDescription": "Crie e gerencie cursos que ajudem os membros a adquirir novas habilidades ou conhecimentos.",
      "eventsDescription": "Planeje, organize e visualize as próximas sessões, workshops ou eventos comunitários.",
      "leaderboardDescription": "Reconheça os membros de alto desempenho e incentive um engajamento saudável por meio de classificações.",
      "membersDescription": "Gerencie todos os membros e funções. Esta aba permanecerá visível para os administradores mesmo quando desativada, para que o gerenciamento de membros esteja sempre acessível.",
      "aboutDescription": "Apresente o propósito, os valores e o histórico da sua comunidade para ajudar os membros a se conectarem.",
      "discussionTooltip": "A aba de Discussão é uma parte central da comunidade e não pode ser desativada.",
      "aboutTooltip": "A aba Sobre é necessária para fornecer informações essenciais da comunidade e não pode ser desativada."
    },
    "groupSettings": {
      "groupSettings": "Configurações do Grupo",
      "changeGroupType": "Alterar Digitar de Grupo",
      "changeGroupTypeDescriptionPrivateToPublic": "Dinâmico para um Público Grupo significa que todas as Solicitações pendentes serão aceitas automaticamente e o conteúdo ficará visível ao público. Prosseguir?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dinâmico para um Privado Grupo significa que novos Membros precisa de Aprovação e Conteúdo permanece Oculto até que sejam Aceito. Prosseguir?",
      "changeGroupTypeConfirmation": "Tem certeza de que deseja alterar o Grupo Digitar?",
      "changeGroupTheme": "Alterar Tema do Grupo",
      "changeGroupThemeDescription": "Isso alterará o tema para todos os Membros do Grupo. Tem certeza de que deseja alterar o grupo tema?",
      "updatedGroupDetails": "Detalhes Atualizado do Grupo",
      "unableToSaveDetails": "Ops! Não é possível Arquivar Detalhes.",
      "groupNameIsRequired": "O nome do grupo é Obrigatório",
      "groupDescriptionIsRequired": "O grupo Descrição é obrigatório",
      "groupSlugIsRequired": "O Grupo Slug é obrigatório",
      "groupSlugMustContainOnly": "O grupo Slug deve conter apenas letras Minúsculas, Quantidade e funis",
      "groupSlugAlreadyExists": "O Slug do Grupo já existe. Use um Slug diferente, pois este já está sendo usado",
      "groupSlugRestricted": "Este slug corresponde a uma de nossas palavras-chave restritas para links da comunidade. Use um slug diferente.",
      "pleaseTryAgainLater": "Tente de novo mais tarde",
      "unsavedChangesMessage": "Você tem não salvo o Grupo Slug Dinâmico, Tem certeza de que deseja desfazer eles?"
    },
    "import": {
      "header": "Importar Membros do Grupo Slug e seu Conteúdo",
      "credentialDescription": "Insira seu Copiado para importar seu Grupo Membros e seu conteúdo",
      "csvUploadDescription": "selecionar .csv Arquivo para importar contatos De Shool",
      "loginFailed": "Você adicionou uma password inválida por e-mail ou . Tente de novo.",
      "proceedWithImport": "Prosseguir com a Importar?",
      "iAgree": "Eu concorda",
      "importTerms": "Via em \"Concordo\", Você confirmar e reconhece que Você nos nomeou como um acordo inde Os serviços Incluir a transferência de alguns dados, detalhes, conteúdo, propriedades inteligentes ou qualquer outro conteúdo (\" Informações \") De uma conta da plataforma de emito para uma conta da plataforma recebida. Você representa e certifica que (i) Você é o Proprietário de verdade das Informações in Plataforma de Emito Conta, (Ii) Você tem as permissões para nos conceder acesso à Plataforma de Emito de Conta para a intenção de executar os serviços, e (3) a Transferência das Informações não violará nenhuma Propriedades Integrativas de terceiros de terceiros ou violará quaisquer contratos de terceiros. Você concorda em indenizar, proteger e nos espera inócuos por quaisquer reivindicações de terceiros que aparecerem como resultado de sua violada dos formulários e seguranças acima.",
      "pleaseDownloadCSV": "Baixe o Arquivo .CSV",
      "step01": "Etapa 01-",
      "step02": "Etapa 02-",
      "uploadCSV": "Carregar seu .CSV",
      "step01Description": "Preencher in Ou atualize todos os detalhes ausentes para os membros do Grupo, como Gmail, nome etc. Certifique-se de que o CSV seja carregado in",
      "thisTemplate": "este modelo",
      "importCSV": "Importar .CSV",
      "reSyncData": "ReSincronização seus dados Antes de Baixar.",
      "refreshUserList": "Atualizar lista de usuários",
      "reSyncDataDescription": "Se novo usuário for adicionado in isso, recomendamos Você para atualizar sua Lista e Baixar o CSV.",
      "pleaseDontChangeProfileSlug": "Não altere o perfil Slug.",
      "selectFile": "Selecionar Arquivo",
      "changeFile": "Alterar Arquivo",
      "importMembersFailedText": "Isso pode ocorrer porque estão faltando o endereço de e-mail. Marca de verificação seu Importar Arquivo e Tentar de novo com endereço de e-mail válido para esses membros.",
      "upload": "Carregar",
      "tryAgain": "Tentar de novo",
      "importerAnotherGroup": "Start New Import",
      "syncAllPosts": "Sincronização de todos o seu Compartilhar e comentário",
      "membersCouldNotBeAdded": "Não foi possível adicionar os Membros ao Grupo.",
      "importMembersSuccess": "Enviamos um e-mail para todos os Indivíduos do Grupo Membros, confirmada sua Filiação in Grupo e forneça a eles o Acesso Detalhes. Isso ajuda a certifique-se de que todos os Membros sejam atualizados e podem acessar com o grupo com eficiência.",
      "importMembersAdded": "Os Membros foram adicionados com sucesso ao Grupo",
      "postsNotSynced": "As publicações restantes não podem ser sincronização para o grupo. Isso pode ocorrer porque as Compartilhar Autores não foram importadas com sucesso.",
      "migrationFailed": "A migração falhou. Tente de novo.",
      "migrationCompleted": "Migração concluída!",
      "migrationInProgress": "Migração em andamento",
      "createProfile": "Criar perfil",
      "enterCredentials": "Insira as credenciais",
      "uploadingInProgress": "Carregar in andamento!",
      "listMembers": "A Lista de Membros está sendo",
      "downloaded": "Baixar",
      "uploaded": "carregado",
      "listPostsDownloaded": "A lista de publicações é Baixar.",
      "listPostsDownloading": "A lista de publicações está sendo Baixar.",
      "posts": "publicações",
      "members": "Membros",
      "imported": "importado",
      "step1": "Etapa 1",
      "step2": "Etapa 2",
      "step1Description": "Criar um Membros Perfil in Skouel Grupo.",
      "step1Description2": "(incluindo nome, Id e-mail e senha)",
      "step2Description": "Insira o Membros doknoo.",
      "skoolUrlPlaceholder": "Insira o URL do seu grupo Skool",
      "emailPlaceholder": "Insira Idde e-mail do seu Slug",
      "emailTooltip": "Insira o e-mail dos Membros com sua Conta do Slug",
      "passwordPlaceholder": "Digite a senha do seu Slug",
      "confirm": "Confirmar",
      "validation": {
        "skoolUrl": "Insira um URL válido do Slug",
        "email": "O e-mail é obrigatório",
        "password": "A senha é obrigatória"
      }
    },
    "approved": "Aprovado",
    "pending": "Pendente",
    "rejected": "Rejeitado"
  },
  "invitations": {
    "intent": "Ajude esta comunidade a crescer!",
    "cancelInvitation": "Cancelar convite",
    "inviteMembers": "Convide membros para colaborar nesta comunidade.",
    "inviteLink": "Link de convite",
    "invitationLink": "link de convite",
    "buildYourCommunity": "Construa sua comunidade!",
    "inviteMembersToCollaborate": "Você criou uma nova comunidade! Convide membros para colaborar nesta comunidade.",
    "invite": "Convidar",
    "basicInformation": "Detalhes básicos",
    "permissions": "Permissões"
  },
  "createPost": {
    "title": "Criar nova publicação no blog",
    "placeholder": "No que está pensando",
    "liveStream": "Transmissão ao vivo",
    "slug": "Slug da publicação no blog",
    "titleHelp": "O título, a descrição e a imagem serão usados para a meta tag de SEO",
    "nameLabel": "Título da publicação no blog",
    "nameValidation": "O título é obrigatório",
    "descriptionLabel": "Descrição da publicação",
    "descriptionHelp": "Forneça um rótulo curto para que os espectadores tenham uma ideia da publicação. Funciona melhor com 100 a 250 caracteres",
    "descriptionValidation": "A descrição é obrigatória",
    "createLabel": "Criar publicação",
    "image": "Imagem da publicação no blog",
    "imageDescription": "O tamanho recomendado é 600px * 400px",
    "notificationTitle": "Publicação no blog criada",
    "notificationErrorTitle": "Falha ao criar publicação no blog",
    "postingIn": "Publicando in",
    "editingIn": "Editando in"
  },
  "post": {
    "downloadRecording": "Baixar Gravação",
    "deletePost": "Excluir publicação",
    "reportPost": "Denunciar publicação",
    "editPost": "Editar publicação",
    "createPost": "Criar publicação",
    "publish": "Publicação",
    "publishPost": "Publicar Postagem",
    "addChannel": "Adicionar canal",
    "selectChannel": "Selecione o canal",
    "addLink": "Adicionar link",
    "removeLink": "Remover link",
    "update": "Atualizar",
    "unsavedChanges": "Você tem alterações não salvas",
    "unsavedChangesMessage": "Suas alterações não salvas serão perdidas. Você ainda deseja continuar?",
    "unpinFromChannel": "Desafixar",
    "unpinFromHome": "Desafixar",
    "deletePostConfirmation": "Tem certeza de que deseja excluir esta publicação?",
    "reportPostConfirmation": "Tem certeza de que deseja denunciar esta publicação?",
    "postNotFound": "Publicação não encontrada",
    "postNotFoundMessage": "A publicação que você está tentando visualizar foi apagada ou não existe.",
    "loadMoreComments": "Carregar mais comentários",
    "channelNotFound": "Canal não encontrado",
    "isCurrentlyLive": "está ao vivo agora",
    "isStartingNow": "está começando agora",
    "isHappeningInMinutes": "está acontecendo em {minutes} minutos",
    "isHappeningInHours": "está acontece in {hours} hora | está acontece in {hours} hora",
    "publicChannel": "Canal público",
    "privateChannel": "Canal privado",
    "featured": "Em destaque",
    "featuredAbout": "Sobre os destaques",
    "noPostsFound": "Nenhuma publicação encontrada",
    "pinInfo": "Você pode fixar itens a serem exibidos no topo do grupo, incluindo publicações, regras e hashtags.",
    "pinInfoEveryone": "Todo mundo no grupo verá esses itens.",
    "pinInfoRemainVisible": "Os itens fixados permanecem visíveis até que você os solte.",
    "pinInfoNewestItem": "À medida que você fixa itens, o item mais recente aparece na frente da lista.",
    "onlyVisibleToAdmins": "Visível apenas para administradores",
    "featuredAboutDescription": "Seus administradores fixaram esses itens para o grupo ver.",
    "channelNotFoundMessage": "Você não é mais membro do canal que está tentando acessar ou o canal foi apagado.",
    "notifications": {
      "unpinned": "Desafixado!",
      "pinned": "Fixado!",
      "reported": "A publicação foi reportada!",
      "error": "Algo deu errado!",
      "isCommentDisabled": "Feedback desabilitado!",
      "isCommentEnabled": "feedback habilitado!",
      "createPost": "Erro ao criar postagem",
      "editPost": "Erro ao editar publicação",
      "POST_CONTENT_SIZE_EXCEEDED": "O conteúdo da publicação é grande demais. Reduza o tamanho e tente novamente."
    },
    "movePostToChannel": "Mover para canal",
    "pin": "Pin",
    "pinToHome": "Fixar na página inicial",
    "pinToChannel": "Fixar no canal",
    "whatIsYourTitle": "Qual é o seu título?",
    "postMovedToChannel": "Compartilhar movido para o canal {channelName}",
    "upcomingEvent": "Evento futuro",
    "turnOffCommenting": "Desativar comentários",
    "enableComments": "Ativar comentários",
    "disableComments": "Desabilitar feedback",
    "moveToPrivateChannelConfirmation": {
      "title": "Mover para o canal privado",
      "message": "Você está prestes a mover esta publicação para um canal privado. Somente os membros desse canal privado poderão ver. Quer continuar?"
    },
    "onlyAdminsCanPost": "Somente administradores da comunidade podem Compartilhar neste Canal."
  },
  "reaction": {
    "noLikes": "Sem curtidas",
    "andOthers": "e {count} outros"
  },
  "UIConfirmation": {
    "privateGroup": "Este grupo é privado",
    "privateGroupMessage": "Você precisa ser membro deste grupo para acessar informações específicas do grupo. Solicite acesso clicando no botão Participar do grupo."
  },
  "notifications": {
    "noNotificationsYet": "Ainda não há notificações",
    "whenYouGetNotifications": "Quando você receber notificações, elas aparecerão aqui",
    "markAllAsRead": "Marcar tudo como lido",
    "notifications": "Notificações",
    "all": "Todos",
    "unread": "Não lidos",
    "checkNotifications": "Faça login para verificar as notificações",
    "noNotifications": "Nenhuma notificação!",
    "redirectedFromOldSlug": {
      "title": "Você foi redirecionado para o link da comunidade atualizado",
      "content": "Isso foi Concluído para melhorar o desempenho de SEO para esta comunidade. Por favor, atualize seus favoritos com este novo URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wahoo! 🎉, Solicitação enviada com sucesso",
    "reviewRequestSoon": "Nossos administradores de grupo analisarão sua solicitação em breve. Por favor, seja paciente e nós o notificaremos assim que sua assinatura for aprovada.",
    "nonMemberMessage": "Você precisa fazer parte deste grupo para curtir e comentar as publicações",
    "subscribeFor": "Inscrever-se para",
    "joinGroup": "PARTICIPAR DO GRUPO",
    "membershipPending": "Filiação pendente",
    "viewMembershipAnswers": "Visualizar respostas de Filiação",
    "requested": "Solicitado",
    "dayFreeTrial": "Teste gratuito de um dia",
    "notPartOfGroup": "Você ainda não faz parte deste grupo, sua Filiação Solicitações está in avaliação. Quando um administrador aceitar suas solicitações, notificaremos Você",
    "pleaseAnswerMembershipQuestions": "Responder às perguntas da Filiação para participar deste Grupo",
    "answerQuestions": "Responder perguntas de associação"
  },
  "userProfilePopover": {
    "active": "Ativo",
    "longAgo": "há muito tempo",
    "chatDisabled": "Este usuário desabilitou seu chat",
    "pointsToLevelUp": "pontos para subir de nível",
    "profile": "Perfil",
    "deletedUser": "Usuário apagado",
    "joined": "Entrou",
    "contributions": "Contribuições"
  },
  "courses": {
    "by": "Por",
    "free": "Gratuito",
    "unknownInstructor": "Instrutor Desconhecido",
    "courseRestricted": "Esta Rota é Privado",
    "courseDeleted": "Este curso foi excluído",
    "noMatchingCourseFound": "Nenhum curso correspondente foi encontrado",
    "addCourse": "Adicionar curso",
    "updateCourse": "Atualizar curso",
    "access": "Todos os membros têm acesso",
    "unableToAddCourse": "Ops! Não foi possível adicionar o curso.",
    "pleaseTryAgainLater": "Tente novamente mais tarde",
    "paymentIntegrationMissing": "Ops! Falta a integração de pagamento",
    "paymentIntegrationMissingMessage": "Por favor, integre os pagamentos no endereço para habilitar cursos pagos",
    "course": "Curso",
    "courseInThisGroup": "um curso existente neste grupo",
    "courseLinkCopied": "Link do curso copiado!",
    "buyNow": "COMPRAR AGORA",
    "locked": "Bloqueado",
    "buyCourse": "COMPRAR CURSO",
    "open": "ABRIR",
    "moveCard": "Mover cartão",
    "courseViewMessage": "Você precisa fazer parte deste grupo para visualizar os cursos.",
    "deleteCourse": "Excluir curso",
    "deleteCourseConfirmation": "Tem certeza de que deseja excluir este curso?",
    "courseAccessNotGranted": "Acesso ao curso não concedido",
    "courseAccessNotGrantedMessage": "No momento, estamos trabalhando para conceder acesso ao curso. Atualize a página e tente novamente em instantes.",
    "autoRenewsAfter": "Renova automaticamente depois de",
    "oneTimePayment": "Pagamento único",
    "emptyCoursesMessage": "Parece uma cidade fantasma. Nada para ver aqui",
    "updatedSuccessfully": "Curso atualizado com sucesso",
    "addedSuccessfully": "Curso adicionado com sucesso",
    "createCourse": "Criar novo curso",
    "emptyCourseLibrary": "Sua biblioteca de cursos está vazia!",
    "createdOutsideGokollabMessage": "Esta comunidade foi criada fora do Gokollab & e tornou-se visível. Para Gerar novos Cursos, faça login na comunidade De sua Fonte Canal.",
    "createCourseOnGokollabMessage": "Gerar um novo Rota Ativado Gokollab para Criar-lo disponível aos Membros da sua comunidade.",
    "or": "ou",
    "createNewOne": "crie um novo",
    "labels": {
      "selectCourse": "Selecionar curso",
      "courseVisibility": "Visibilidade do curso",
      "courseAccess": "Acesso ao curso",
      "coursePrice": "Preço do curso",
      "subscriptionType": "Tipo de assinatura",
      "billingPeriod": "Período de faturamento",
      "testMode": "Modo de teste",
      "turnOnTestPayments": "Ative os pagamentos de teste usando um cartão de teste",
      "currency": "Moeda",
      "trialDays": "Dias de teste",
      "recurring": "Recorrente",
      "free": "Gratuito",
      "oneTime": "Um dado",
      "refresh": "Atualizar",
      "accessStartsAtDay": "O Acesso começa no Dia",
      "maximumYouCanEnterIs365": "O máximo que você pode inserir é 365",
      "allMembers": "todos Membros",
      "levelUnlock": "Desbloquear plano",
      "buyNow": "Compra agora",
      "timeUnlock": "Desbloquear dados",
      "gamificationLevel": "Gamificação Plano",
      "privateChannel": "Canal Privado",
      "private": "Privado",
      "marketingChannel": "Canal de Marketing",
      "selectCurrency": "Selecionar moeda"
    },
    "placeholders": {
      "enterPrice": "Insira o preço",
      "enterTrialDays": "Insira os dias de teste",
      "selectCurrency": "Selecione um",
      "selectBillingPeriod": "Selecione um",
      "billingPeriod": "Selecionar período de faturamento"
    },
    "validations": {
      "validPrice": "Insira um preço válido",
      "required": "Selecione um curso",
      "validMembershipPrice": "Insira um preço de assinatura válido",
      "validTrialDays": "Insira dias de teste válidos",
      "requiredSubscriptionType": "Selecione o tipo de assinatura",
      "courseVisibility": "Selecione a Visibilidade do curso",
      "requiredGamificationLevel": "Selecione o Gamificação Plano",
      "requiredPrivateChannel": "Selecione o canal Privado",
      "validAccessStartDay": "Insira um dia de início de acesso válido"
    },
    "descriptions": {
      "buyNowDescription": "Este curso é Público na compra",
      "timeUnlockDescription": "Membros Desbloquear depois X dias",
      "levelUnlockDescription": "Os Membros somente em um específico Plano poderão desbloquear",
      "allMembersDescription": "todos os membros têm acesso a este curso",
      "privateChannelDescription": "Membros de um canal privado",
      "privateDescription": "Acesso concedido somente pelo administrador"
    },
    "helperText": {
      "levelBased": "Com base em nível",
      "timeLimited": "hora-limitada",
      "privateBased": "Privado",
      "free": "Gratuito",
      "levelAvailableAt": "Disponível no Plano 0{value}",
      "timeLimitedAfterJoining": "Público {value} {day} Depois de ingressar no Grupo",
      "day": "Dia",
      "days": "dias",
      "purchaseToUnlockAccess": "Compra este curso para acessar o Acesso",
      "privateCourse": "Curso privado - Acesso concedido somente pelo administrador",
      "locked": "Este curso está bloqueado",
      "unlockAtLevel": "Este curso será bloqueado no Plano {level}",
      "unlockAfterDays": "Este curso abrirá Depois {days} {dayText}",
      "privateChannelBased": "Com base em canal Privado",
      "externalAccess": "Outro Grupo/Oferta"
    },
    "manageAccess": {
      "manageCourses": "Gerenciar cursos",
      "revokeCourseAccess": "Gerencie Cursos",
      "grantCoursesAccess": "Conceder cursos",
      "removeAccess": "Remover acesso",
      "grantAccess": "Conceder acesso",
      "grant": "Conceder",
      "clear": "Limpar",
      "selectAll": "Selecionar tudo",
      "revokeAccessConfirmTitle": "Remover o acesso ao curso?",
      "revokeAccessConfirmMessage": "Tem certeza de que deseja remover o acesso a \"{courseName}\" para {userName}?",
      "externalAccessTooltip": "Não é possível remover: o usuário tem acesso de outro grupo ou oferta",
      "cannotRevokeAutoAccess": "Não é possível remover: o acesso é concedido automaticamente com base nas configurações do curso (pago, nível, tempo ou gratuito)",
      "searchPlaceholder": "Procurar cursos",
      "noCoursesFound": "Nenhum curso encontrado",
      "noCoursesSelected": "Ainda não há cursos selecionados",
      "noCoursesAvailable": "Nenhum curso disponível para conceder",
      "noSearchResults": "Nenhum resultado da pesquisa",
      "failedToLoadCourses": "Falha ao carregar os cursos",
      "accessRevoked": "Acesso ao curso removido com sucesso",
      "failedToRevokeAccess": "Falha ao remover o acesso ao curso",
      "accessGranted": "Acesso ao curso concedido com sucesso",
      "multipleAccessGranted": "{count} cursos concedidos com sucesso",
      "failedToGrantAccess": "Falha ao conceder acesso ao curso"
    },
    "ariaLabels": {
      "courseCard": "Cartão do curso",
      "courseCardActions": "Ações do cartão do curso",
      "editCourse": "Editar curso",
      "deleteCourse": "Excluir curso",
      "moveCard": "Mover cartão",
      "copyLink": "Copiar link",
      "cardImage": "Imagem do cartão do curso"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Erro ao enviar o arquivo"
    },
    "uploadLinkVideo": "Carregar/vincular vídeo",
    "removeMedia": "Remover {fileName} Mídia"
  },
  "leaderboard": {
    "level": "Nível",
    "lastUpdated": "Atualizado em",
    "members": "Membros",
    "percentOfMembers": "{percentage}% dos membros",
    "rewards": "Recompensas",
    "allTime": "Todo o tempo",
    "pointsToLevelUp": "pontos para subir de nível",
    "points": "Pontos",
    "leaderboard7d": "Tabela de classificação (7 dias)",
    "leaderboard30d": "Tabela de classificação (30 dias)",
    "leaderboardAlltime": "Tabela de classificação (todo o tempo)",
    "yourRank": "Sua classificação",
    "noActivityToShow": "Nenhuma atividade para exibir",
    "rewardsWillBeDisplayedHere": "As recompensas serão exibidas aqui",
    "seeAllLeaderboards": "Ver todas as tabelas de classificação",
    "addRewards": "Adicionar Recompensas",
    "howPointsWork": "Você ganha pontos quando outros membros curtem suas publicações ou feedback. 1 curtida = 1 ponto. Isso incentiva os Usuários a Gerar conteúdo de qualidade e a interagir com outros Membros da comunidade.",
    "levels": "Níveis",
    "levelsDescription": "À medida que ganha pontos, você sobe de nível. Seu nível é mostrado na parte inferior direita do seu avatar. O número de pontos necessários para passar para o próximo nível é mostrado via a barra de progresso na página Leaderboard.",
    "pointsAndLevels": "Pontos e Camadas"
  },
  "events": {
    "createEvent": "Criar evento",
    "dragAndDrop": "Arrastar e soltar um SVG, PNG ou JPG (Max 800 x 400px)",
    "editEvent": "Editar evento",
    "addEvent": "Adicionar evento",
    "paymentDetails": "Detalhes do pagamento",
    "event": "Evento",
    "goBack": "Voltar",
    "cancelEdit": "Cancelar edição",
    "cancelEvent": "Cancelar Evento",
    "next": "Seguinte",
    "saveEvent": "Salvar evento",
    "editRecurringEvent": "Editar evento recorrente",
    "thisEvent": "Este evento",
    "thisAndFollowingEvents": "Este e os próximos eventos",
    "ok": "OK",
    "deleteRecurringEvent": "Excluir evento recorrente",
    "allEvents": "Todos os eventos",
    "adminsFreeForPaidEvents": " * Os administradores podem se registrar no Pago Eventos para Gratuito",
    "deleteEvent": "Excluir evento",
    "onceEventDeleted": "Depois que o evento for apagado, ele não será exibido no seu calendário.",
    "toRegister": "para registrar",
    "calendar": "Calendário",
    "addToCalendar": "Adicionar ao calendário",
    "declineRegistration": "Recusar",
    "paymentFailedMessage": "Seu pagamento falhou devido a algumas circunstâncias imprevistas! Tente novamente mais tarde.",
    "upcoming": "Próximos",
    "noMoreEvents": "Não há mais eventos para exibir",
    "joinGroupToRegister": "Você precisa fazer parte deste grupo para se inscrever neste evento",
    "past": "Passado",
    "youHaveRegisteredForOneEvent": "Você se registrou para um evento. Enviaremos um lembrete um dia antes de cada evento.",
    "upcomingEvents": "Próximos eventos",
    "noUpcomingEvents": "Não há eventos futuros",
    "pastEvents": "Eventos passados",
    "noPastEvents": "Nenhum evento passado",
    "noMatchingEventFound": "Nenhum evento correspondente encontrado",
    "recordings": "Gravações",
    "week": "Semana",
    "month": "Mês",
    "today": "Hoje",
    "registrationConfirmed": "Confirmado de registro para {event}.",
    "eventDeletedOrRestricted": "O evento foi excluído ou restrito",
    "eventDeleted": "O evento foi excluído",
    "eventRestricted": "Você não tem acesso a este evento",
    "validations": {
      "titleValidation": "O título é obrigatório",
      "colorValidation": "A cor é obrigatória",
      "startTimeValidation": "A hora de início é obrigatória",
      "endTimeValidation": "A hora de término é obrigatória",
      "endTimeAfterStartTime": "A hora de término deve ser posterior à hora de início",
      "startTimeMustBeInFuture": "A hora de início deve ser no futuro",
      "locationValidation": "A localização é obrigatória",
      "locationValidationMobile": "Localização é obrigatória",
      "locationUrlValidation": "É necessário um URL de localização válido",
      "descriptionValidation": "A descrição é obrigatória",
      "descriptionValidationMaxLength": "A descrição não pode exceder 300 caracteres",
      "recaptchaError": "A verificação falhou! Tente novamente",
      "repeatIntervalValidation": "A frequência é obrigatória",
      "repeatIntervalValidator": "O intervalo de repetição deve ser dia, semana, mês ou ano",
      "repeatIntervalRequired": "O intervalo de repetição é obrigatório",
      "repeatOccurrenceValidator": "A frequência de repetição deve ser maior que 0",
      "repeatOccurrenceRequired": "A frequência de repetição é obrigatória",
      "invalidDateFormat": "Formato de data inválido",
      "endDateMustBeAfterStartDate": "A data de término deve ser posterior à data de início do evento",
      "recurringEndDateValidation": "A data de término recorrente é obrigatória",
      "repeatsOnValidation": "Selecione pelo menos um dia",
      "invalidDaySelection": "Seleção de dia inválida",
      "endOptionRequired": "A opção de término é obrigatória",
      "levelValidation": "Selecione um nível",
      "courseValidation": "Selecione um curso",
      "channelValidation": "Selecione um canal",
      "eventPriceValidation": "O preço é Obrigatório e deve ser maior que {min}"
    },
    "placeholders": {
      "selectStartTime": "Selecionar horário de início",
      "selectEndTime": "Selecionar horário de término",
      "selectLocation": "Selecionar localização",
      "locationUrl": "Link/Endereço",
      "description": "Descrição",
      "selectRecurringEndDate": "Selecione a data de término recorrente",
      "selectDate": "Selecionar data",
      "event": "Evento",
      "selectColor": "Selecione uma cor",
      "selectAttendees": "Selecionar participantes",
      "selectPrivateChannel": "Selecionar canal privado",
      "selectCourse": "Selecionar curso",
      "selectLevels": "Selecionar Níveis",
      "selectCalendar": "Selecionar calendário"
    },
    "labels": {
      "startTime": "Hora de início",
      "endTime": "Hora de término",
      "others": "Outros",
      "oneTimePriceForEventRegistration": "preço único para inscrição no evento.",
      "totalAmount": "Valor total",
      "cardAuthorizationText": "Ao fornecer as informações do seu cartão, você permite que {locationName} cobre o cartão para pagamentos futuros de acordo com os termos.",
      "secureAndSafePayments": "Pagamentos totalmente seguros e protegidos",
      "day": "Dia",
      "week": "Semana",
      "month": "Mês",
      "year": "Ano",
      "recurringEvent": "O evento será recorrente?",
      "repeatsEvery": "Repete a cada",
      "repeatsOn": "Repete em",
      "end": "Fim",
      "ends": "Fim",
      "neverEnds": "Nunca acaba",
      "orange": "Laranja",
      "red": "Vermelho",
      "blue": "Azul",
      "green": "Verde",
      "violet": "Violeta",
      "purple": "Roxo",
      "yellow": "Amarelo",
      "title": "Título",
      "color": "Cor",
      "allMembers": "Todos os membros",
      "membersAtALevel": "Membros em um nível",
      "membersOfACourse": "Membros de um curso",
      "membersOfAPrivateChannel": "Membros de um canal privado",
      "whoCanAttendTheEvent": "Quem pode participar do evento?",
      "channel": "Canal",
      "course": "Curso",
      "level": "Nível",
      "remindAttendeesByEmail": "Lembre os participantes por e-mail 1 dia antes",
      "hideLocationFromNonAttendees": "Ocultar a localização de não participantes.",
      "addChargesToTheEvent": "Adicionar receita ao evento",
      "noPaymentRequired": "Nenhum pagamento Obrigatório",
      "location": "Localização",
      "link": "Link",
      "description": "Descrição",
      "timezone": "Fuso horário",
      "eventType": "Tipo de evento",
      "eventTypeChangeWarning": "Dinâmico para o tipo de evento Ou a precificação aplicará a todas as ocorrências in serie.",
      "never": "Nunca",
      "on": "Ativado",
      "after": "Depois",
      "occurrences": "ocorrências",
      "selectEventEnd": "selecionar Quando o evento será Fim.",
      "turnOnTestPayments": "Virar Ativado Pagamentos do Testar Via um cartão Testar",
      "pay": "Pagar",
      "hideAttendees": "Convidados ocultos De Grupo Membros",
      "guests": "{count} convidados",
      "guestList": "Lista de Convidado",
      "noAttendees": "Ainda não há participantes",
      "viewAttendees": "Visualizar participantes",
      "exportAttendees": "Exportar participantes"
    },
    "notifications": {
      "eventCreated": "Evento criado com sucesso!",
      "pickImageFailed": "Falha ao selecionar a imagem",
      "pickImageFailedContent": "Ocorreu um erro ao selecionar a imagem.",
      "eventUpdated": "Evento Atualizado com sucesso!",
      "eventCreationFailed": "Falha na criação do Evento !",
      "eventUpdateFailed": "Falha na atualização do Evento !",
      "EVENT_CREATE_INVALID_TIME_RANGE": "A hora de início deve ser anterior à hora de término.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED": "A hora de início deve ser no futuro.",
      "EVENT_CREATE_DURATION_EXCEEDED": "A duração do evento excede o limite máximo permitido.",
      "EVENT_CREATE_FAILED": "Não foi possível criar o evento. Tente de novo.",
      "EVENT_UPDATE_NOT_FOUND": "Não foi possível atualizar o evento porque ele não foi encontrado.",
      "EVENT_UPDATE_UNAUTHORIZED": "Você não tem permissão para atualizar este evento.",
      "EVENT_UPDATE_INVALID_OPERATION": "Esta ação de atualização de evento não é permitida.",
      "eventDeleted": "Evento excluído com sucesso!",
      "eventDeletionFailed": "Falha ao excluir evento!",
      "paymentFailed": "O pagamento falhou!",
      "registrationSuccessful": "Registro bem-sucedido!",
      "registrationFailed": "Falha no registro!",
      "addToCalendarFailed": "Falha ao adicionar evento ao calendário!",
      "locationDetailsCopied": "Detalhes da localização copiados para a área de transferência!",
      "registrationDeclined": "O registro foi recusado com sucesso!",
      "registrationDeclinedFailed": "A recusa do registro falhou!",
      "fetchAttendeesFailed": "Falha ao carregar participantes",
      "emailCopied": "Enviar e-mail copiado para a área de transferência",
      "exportAttendeesFailed": "Falha ao exportar os participantes"
    },
    "selectCalendar": "Selecionar calendário",
    "eventImage": "Imagem do evento",
    "errorLoadingEvent": "Erro ao carregar evento"
  },
  "login": {
    "invite": "convidou você a participar"
  },
  "contentReports": {
    "contentDeleted": "O conteúdo foi excluído!",
    "noActionTaken": "Nenhuma ação tomada sobre o conteúdo denunciado!",
    "reportedContentNotFound": "O conteúdo denunciado não foi encontrado, ele pode já ter sido processado.",
    "reported": "Denunciado",
    "viewAllReportedContentHere": "Você pode visualizar todo o conteúdo denunciado aqui",
    "takeActionOnReportedContent": "Tome medidas sobre o conteúdo denunciado",
    "andOthers": "e {count} outros",
    "reportedThisPost": "denunciou(aram) esta publicação",
    "keep": "MANTER",
    "remove": "REMOVER",
    "deleteContent": "Excluir conteúdo",
    "deleteConfirmation": "Tem certeza de que deseja excluir este conteúdo?",
    "noMemberReportedContent": "Nenhum conteúdo denunciado por membros",
    "whenMembersReportPostsOrComments": "Quando os membros denunciarem publicações ou feedbacks, eles aparecerão aqui para você avaliar. Você pode manter ou excluir, bem como suspender, remover ou bloquear os membros que publicaram.",
    "reportedThisComment": "Você denunciou este comentário"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Este conteúdo não está disponível no momento",
    "whenThisHappens": "Quando isso acontece, geralmente é porque o proprietário só o compartilhou com um pequeno grupo de pessoas, alterou quem pode visualizá-lo ou foi apagado"
  },
  "search": {
    "noResultsFor": "0 resultados para \"{query}\" na comunidade",
    "noResultsFound": "Nenhum resultado encontrado"
  },
  "noCommunities": {
    "noCommunitiesFound": "Nenhuma comunidade encontrada",
    "startCreatingYourOwnCommunities": "Comece a criar suas próprias comunidades e interaja com seu público!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Não entrou em um",
      "communities": "Comunidades",
      "yet": "Ainda"
    },
    "noCommunitiesFoundGokollabDescription": "Descubra espaços onde as pessoas compartilham ideias, apoiam umas às outras e crescem juntas."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Não inscrito em um",
      "course": "Curso",
      "yet": "Ainda"
    },
    "noCoursesFoundGokollabDescription": "Explore cursos de alto impacto criados para ajudar você a aprender, melhorar e ter sucesso."
  },
  "notFound": {
    "ohNo": "oh não...",
    "weHaveHadAnError": "Tivemos um erro",
    "error404": "Erro 404",
    "sorryPleaseCheckBack": "Desculpe...volte em um minuto."
  },
  "time": {
    "justNow": "agora",
    "timeAgo": "há {value} {unit}",
    "timeAgoFull": "há {value} {unit}",
    "units": {
      "year": "a",
      "years": "anos",
      "month": "m",
      "months": "meses",
      "week": "sem",
      "weeks": "semanas",
      "day": "d",
      "days": "dias",
      "hour": "h",
      "hours": "horas",
      "minute": "m",
      "minutes": "minutos",
      "second": "s",
      "seconds": "Segundos",
      "monthly": "Mensalmente",
      "weekly": "Semanalmente",
      "annually": "Anual"
    },
    "dayAbbreviations": {
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb",
      "sun": "Dom"
    }
  },
  "emojiPicker": {
    "notfound": "Nenhum Emoji encontrado",
    "recent": "Usado com frequência",
    "smileys": "Smileys e Emoticon",
    "people": "Pessoas e Corpo",
    "nature": "Animais e Natureza",
    "foods": "Alimento e consumo",
    "activity": "Atividade",
    "places": "Viagens e Assentos",
    "objects": "Objetos",
    "symbols": "Símbolos",
    "flags": "Marcadores",
    "custom": "Personalizado(a)"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussão",
    "learning": "aprendizado",
    "people": "Pessoas"
  },
  "globalUserProfile": {
    "ownedBy": "Propriedade de {name}",
    "memberships": "Assinaturas",
    "membershipsInCommon": "Assinaturas ({count} em comum)",
    "membersCount": "{count} membros",
    "contributions": "{count} contribuições para {group}",
    "contributionsFor": "Contribuições para",
    "justPosts": "Apenas publicações",
    "postAndComments": "Publicação e comentários",
    "followSuccess": "Você começou a acompanhar o Próximo",
    "unfollowSuccess": "Você não está mais próximo"
  },
  "profile": {
    "active": "Ativo",
    "ago": "atrás",
    "bio": "Bio"
  },
  "golive": {
    "golive": "Entrar ao vivo",
    "liveRoom": "Sala ao vivo",
    "defaultEventTitle": "Evento ao vivo da comunidade",
    "meetingCreationFailed": "Falha ao criar reunião GoLive. Tente novamente.",
    "selectVideoSourceToStart": "Selecione uma fonte de vídeo para começar a transmitir",
    "chooseHowToGoLive": "Selecione como deseja entrar ao vivo",
    "flipCamera": "Virar Câmera",
    "participants": "Participantes",
    "chats": "Chats",
    "react": "React",
    "raise": "Elevar",
    "shareScreen": "Compartilhar",
    "letsCheckYourCamAndMic": "Vamos verificar sua câmera e microfone",
    "hostedBy": "Hospedado por",
    "join": "Participar",
    "needCameraPermission": "Requer autorização para a câmera",
    "needMicrophonePermission": "Requer autorização para o microfone",
    "needSpeakerPermission": "Requer permissão para o alto-falante",
    "createLiveVideo": "Criar um vídeo ao vivo",
    "host": "Host",
    "chooseWhereToPost": "Escolha onde publicar",
    "whenAreYouGoingLive": "Quando você estará ao vivo?",
    "postingIn": "publicando em",
    "live": "Ao vivo",
    "postDetails": "Detalhes da publicação",
    "streamingSoftware": "Apps de streaming",
    "streamingSoftwareDescription": "Você pode usar um app de streaming como Zoom, OBS ou StreamYard para transmitir diretamente. Basta copiar o URL de transmissão e a chave de transmissão fornecidos e colá-los nas configurações do seu app de streaming. Após a configuração, inicie a transmissão no app, e ela será transmitida ao vivo automaticamente para o canal selecionado.",
    "streamKey": "Chave de transmissão",
    "streamKeyDescription": "Isso pode ser reutilizado todas as vezes que você entrar ao vivo. Com seu token de fluxo persistente, você só pode transmitir um vídeo ao vivo por vez.",
    "serverUrl": "URL do servidor",
    "serverUrlDescription": "Isso pode ser chamado de \"URL\" ou \"Endereço\" no seu app de streaming.",
    "selectVideoSource": "Selecione a fonte de vídeo",
    "copyPasteStreamKey": "Copie e cole a chave de transmissão no seu app de streaming.",
    "copyPasteServerUrl": "Copie e cole o URL do servidor no seu app de streaming.",
    "addPostDetails": "Adicionar detalhes da publicação",
    "enterTitle": "Insira o título",
    "notifyMembers": "Avise os membros quando a transmissão estiver ao vivo (envia apenas notificações no aplicativo e notificações push)",
    "notifyMembersMobile": "Notifique os membros de que você vai entrar ao vivo",
    "meetingRoom": "Sala de conferência",
    "meetingRoomDescription": "Utilize o recurso Salas de conferência para hospedar sessões ao vivo em que todos os participantes podem ligar suas webcams, ativar o microfone e interagir em tempo real. Isso cria uma experiência de sala virtual semelhante ao Zoom ou ao Google Meet, permitindo que todos se vejam e conversem entre si presencialmente.",
    "cameraControls": "Controles da Câmera",
    "cameraControlsTooltip": "Configure as definições da sua câmara e do áudio antes de iniciar a transmissão ao vivo. Certifique-se de que sua câmera e microfone estejam devidamente conectados e tenham as permissões necessárias.",
    "selectMediaSource": "Selecione uma fonte de mídia",
    "startScreenShare": "Iniciar compartilhamento de tela",
    "stopScreenShare": "Parar compartilhamento de tela",
    "wasLive": "estava ao vivo",
    "isLive": "está ao vivo",
    "goingLive": "está entrando ao vivo",
    "tapToAddDescription": "Toque para adicionar uma descrição...",
    "selectChannel": "Selecione o canal",
    "saveAsPost": "Mantenha a transmissão ao vivo como publicação",
    "selectVideoSourceTooltip": "Você pode escolher entre apps de streaming ou webcam ao transmitir ao vivo:\n\n 1. App de streaming\n • Forneceremos a você uma chave de transmissão e um URL de transmissão.\n   • Você precisa configurar isso no Zoom, OBS ou em qualquer app de terceiros que suporte transmissão ao vivo.\n\n2. Webcam\n • Transmita ao vivo diretamente usando sua câmera e microfone.\n   • Os participantes podem assistir à transmissão ao vivo e interagir pelo chat ao vivo.\n   • Como anfitrião, você pode controlar e revogar o acesso à câmera ou ao microfone a qualquer momento.",
    "pleaseSelectCameraMicrophoneSpeaker": "Selecione a câmera, o microfone e o alto-falante",
    "pleaseStartStreamBeforeGoingLive": "Inicie a transmissão antes de entrar ao vivo",
    "watching": "Assistindo",
    "processingRecording": "Processando gravação",
    "recordingFailed": "Gravação indisponível",
    "recordingFailedDescription": "Encontramos um problema ao processar esta sessão ao vivo, e a gravação não pôde ser salva",
    "streamEndedRecordingWillBeAvailableSoon": "Transmissão encerrada. A gravação está sendo processada e estará disponível em breve.",
    "joinStream": "Participar da transmissão",
    "recordingInProgress": "Gravação em andamento",
    "recordingNotAvailable": "Falha na gravação",
    "leaveSession": "Sair da Sessão",
    "endSession": "Encerrar sessão",
    "rec": "REC",
    "selectCamera": "Selecionar câmera",
    "noCamerasFound": "Nenhuma câmera foi encontrada",
    "cameraPermissionNeeded": "Permissão de câmera necessária",
    "leave": "Sair",
    "chooseMicCam": "Selecione o microfone/câmera",
    "selectMicrophone": "Selecionar microfone",
    "selectSpeaker": "Selecione o alto-falante",
    "noMicrophonesFound": "Nenhum microfone encontrado",
    "noSpeakersFound": "Nenhum alto-falante encontrado",
    "microphonePermissionNeeded": "É necessário obter permissão para usar o microfone",
    "speakerPermissionNeeded": "É necessária a permissão para usar o alto-falante",
    "noParticipantOpenCamOrMic": "Esta reunião não foi gravada, pois nenhum participante habilitou o microfone ou a câmera. As gravações são criadas apenas quando pelo menos um participante interage."
  }
}
